import React from 'react';
import { List, Collapse } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NavItem } from '../../interfaces/userContext';
import './style.css';
import NavListItem from './NavListItem';

interface NavGroupChildrenProps {
    childrenItems: NavItem[];
    expanded: boolean;
    open: boolean
}

const NavGroupChildren: React.FC<NavGroupChildrenProps> = ({
    childrenItems,
    expanded,
    open
}) => {
    const navigate = useNavigate();
    return (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="nav-collapse-list">
                {childrenItems
                    .sort((a, b) => a.order.localeCompare(b.order))
                    .map((child, idx) => (
                        <NavListItem
                            onClick={() => navigate(`vision${child.path}`)}
                            label={child.name}
                            expanded={expanded}
                            key={`${child.name}-${idx}`}
                            open={open}
                            activePath={child.path}
                        />
                    ))}
            </List>
        </Collapse>
    );
};

export default NavGroupChildren;